/**
 * Query-param helpers.
 *
 * Our backend sometimes sends `email` as Base64 (e.g. dmlzaGFsQGdtYWlsLmNvbQ==).
 * We want the app to transparently accept either raw email or encoded email.
 */
export function decodeMaybeBase64(value: string): string {
  // If it already looks like a normal email, keep it as-is.
  if (value.includes("@")) {return value;}

  // Normalize URL-safe base64 variants and missing padding.
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded =
    normalized.length % 4 === 0
      ? normalized
      : normalized + "=".repeat(4 - (normalized.length % 4));

  try {
    // atob exists in browsers; if decode doesn't look like an email, fall back.
    const decoded = atob(padded);
    return decoded.includes("@") ? decoded : value;
  } catch {
    return value;
  }
}

export function decodeEmailQueryParam(emailParam: string | null): string | null {
  if (!emailParam) {return null;}
  return decodeMaybeBase64(emailParam);
}




// WEBPACK FOOTER //
// ./src/utils/queryParams.ts